var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fileManager"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27799",
    "data-name": "Rectangle 27799",
    width: 16,
    height: 16,
    transform: "translate(26 402)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_611",
    "data-name": "Mask Group 611",
    transform: "translate(-26 -402)",
    clipPath: "url(#fileManager)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_63_",
    "data-name": "svgexport-6 (63)",
    transform: "translate(26.29 402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11421",
    "data-name": "Path 11421",
    d: "M14.379,4.594v-2a.238.238,0,0,0-.238-.238H12.85V.238A.238.238,0,0,0,12.612,0h-9.5A.238.238,0,0,0,2.87.238V2.357H1.578a.238.238,0,0,0-.238.238V6.345h-.21A1.117,1.117,0,0,0,.016,7.461v7.424A1.117,1.117,0,0,0,1.131,16H14.289A1.116,1.116,0,0,0,15.4,14.885V5.705a1.117,1.117,0,0,0-1.026-1.111ZM3.345.475h9.029V4.59H11.32v-2a.238.238,0,0,0-.238-.238H3.345ZM.491,14.885V7.461a.641.641,0,0,1,.64-.64h.93a.238.238,0,0,0,0-.475H1.816V2.832h9.029V4.59H8.436A1.116,1.116,0,0,0,7.32,5.705a.641.641,0,0,1-.64.64H3.012a.238.238,0,1,0,0,.475H6.68A1.117,1.117,0,0,0,7.8,5.705a.641.641,0,0,1,.64-.64h3.972a.641.641,0,0,1,.64.64v9.179a.641.641,0,0,1-.64.64H1.131a.641.641,0,0,1-.64-.64Zm14.438,0a.641.641,0,0,1-.64.64h-.968a1.109,1.109,0,0,0,.2-.547h.622a.238.238,0,0,0,.238-.238V8.44a.238.238,0,0,0-.475,0V14.5h-.38v-8.8a1.117,1.117,0,0,0-.674-1.024V2.832H13.9V7.489a.238.238,0,0,0,.475,0V5.072a.64.64,0,0,1,.55.633Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11422",
    "data-name": "Path 11422",
    d: "M3.068,4.067h5.7a.238.238,0,0,0,0-.475h-5.7a.238.238,0,0,0,0,.475Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11423",
    "data-name": "Path 11423",
    d: "M3.068,5.255H6.331a.238.238,0,0,0,0-.475H3.068a.238.238,0,0,0,0,.475Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11424",
    "data-name": "Path 11424",
    d: "M12.145,7.632H7.2a.238.238,0,0,0-.238.238V9.628a.238.238,0,0,0,.238.238h4.942a.238.238,0,0,0,.238-.238V7.869A.238.238,0,0,0,12.145,7.632ZM11.908,9.39H7.441V8.107h4.467Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileManager);
export default __webpack_public_path__ + "static/media/fileManager.64adb8c517ce8bec1666b62551bc93d3.svg";
export { ForwardRef as ReactComponent };